document.addEventListener('click', function (e) {
  const btn = e.target.closest('.size-help__pill');
  if (!btn) return;

  // Active state
  document.querySelectorAll('.size-help__pill').forEach(b =>
    b.classList.remove('is-active')
  );
  btn.classList.add('is-active');

  // Populate values
  const set = (key, value) => {
    const el = document.querySelector(`[data-k="${key}"]`);
    if (el) el.textContent = value || '—';
  };

  set('body_length_cm', btn.dataset.bodyLengthCm);
  set('body_length_in', btn.dataset.bodyLengthIn);
  set('chest_width_cm', btn.dataset.chestWidthCm);
  set('chest_width_in', btn.dataset.chestWidthIn);
  set('sleeve_from_neck_cm', btn.dataset.sleeveFromNeckCm);
  set('leeve_from_neck_in', btn.dataset.leeveFromNeckIn);
});

// Auto-select first size when modal opens
document.addEventListener('DOMContentLoaded', function () {
  const first = document.querySelector('.size-help__pill');
  if (first) first.click();
});

// Open / close dialog
document.addEventListener('click', function (e) {
  const open = e.target.closest('[data-size-help-open]');
  const close = e.target.closest('[data-size-help-close]');

  if (open) {
    const dialog = document.getElementById(open.dataset.sizeHelpOpen);
    if (dialog) dialog.showModal();
  }

  if (close) {
    const dialog = close.closest('dialog');
    if (dialog) dialog.close();
  }
});
